import type { HomeSectionStatus } from "./homeSection";
import { homeFreshness } from "../homeShellData";

type HomeFreshnessProps = {
    status?: HomeSectionStatus;
    analysisLabel?: string;
    dataPeriodLabel?: string;
};

export const PointMarker = ({ className }: { className?: string }) =>
    (<span className={`d-inline-block flex-shrink-0 rounded-circle !k-bg-primary ${className}`} style={{ width: "0.375rem", height: "0.375rem" }} aria-hidden="true" />);

const HomeFreshness = ({
    status = "ready",
    analysisLabel = homeFreshness.analysisLabel,
    dataPeriodLabel = homeFreshness.dataPeriodLabel
}: HomeFreshnessProps) => {
    if (status === "loading") {
        return <p className="small text-secondary mb-0">Checking the latest analysis...</p>;
    }

    if (status === "error") {
        return <p className="small text-danger mb-0">Unable to load analysis freshness.</p>;
    }

    if (!analysisLabel && !dataPeriodLabel) {
        return <p className="small text-secondary mb-0">Analysis time is not available yet.</p>;
    }

    return (
        <p className="fs-8 mb-0 d-inline-flex align-items-center justify-content-center flex-wrap gap-2 k-text-subtle">
            <PointMarker />
            {analysisLabel && <span>{analysisLabel}</span>}
            {analysisLabel && dataPeriodLabel && <span aria-hidden="true">·</span>}
            {dataPeriodLabel && <span>{dataPeriodLabel}</span>}
        </p>
    );
};

export default HomeFreshness;
